export enum DefaultValueEnum {
  NombreYApellido = 1,
  FechaActual = 2
}

export interface IOStatusDependency {
  IOStatusDependencyID: number;
  AdditionalDefinitionID: number | string;
  Mandatory: boolean;
  Public: boolean;
  IsEditable?: boolean;
  DefaultValue?: number | null;
}

export interface IOStatusEntity {
  IOStatusDependencies: IOStatusDependency[];
  IOStatusID: number;
  Value: string;
  Exclude: boolean;
  Public: boolean;
  PublicValue: string;
  ExcludeCashflow: boolean;
  AlternateDateAdditionalDefinitionID: null | number | string;
  IsPaymentPromise: boolean;
  FieldPaymentPromise?: number;
  ExpirationDaysPaymentPromise: string;
}
